var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigningPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99935 12.5599H10.8327L12.4993 10.8932H4.99935V12.5599ZM4.99935 9.22656H9.99935V7.5599H4.99935V9.22656ZM3.33268 5.89323V14.2266H9.16602L7.49935 15.8932H1.66602V4.22656H18.3327V6.72656H16.666V5.89323H3.33268ZM19.0827 10.3099C19.1521 10.3793 19.1868 10.4557 19.1868 10.5391C19.1868 10.6224 19.1521 10.6988 19.0827 10.7682L18.3327 11.5182L16.8743 10.0599L17.6243 9.3099C17.6938 9.24045 17.7702 9.20573 17.8535 9.20573C17.9369 9.20573 18.0132 9.24045 18.0827 9.3099L19.0827 10.3099ZM10.8327 17.5599V16.1016L16.3743 10.5599L17.8327 12.0182L12.291 17.5599H10.8327Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningPreferences);
export default __webpack_public_path__ + "static/media/signing_preferences.f3b52e42b954d6e5f50646861cc54b31.svg";
export { ForwardRef as ReactComponent };